import ImportIcon from 'components/Icons/ImportIcon';
import React, { memo } from 'react';
import Button from './Button';

interface Iprops {
  onClick?: any;
  setData?: React.Dispatch<any>;
  disabled?: boolean;
}

const ButtonImport = memo(({ onClick, disabled = false }: Iprops) => {
  return (
    <Button
      title="Import"
      disabled={disabled}
      handleOnclick={onClick}
      iconBefore={<ImportIcon />}
    />
  );
});

export default ButtonImport;
